/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgradesuccesstitle2Inputs */

const en_upgradesuccesstitle2 = /** @type {(inputs: Upgradesuccesstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade Successful`)
};

const de_upgradesuccesstitle2 = /** @type {(inputs: Upgradesuccesstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan gewechselt`)
};

/**
* | output |
* | --- |
* | "Upgrade Successful" |
*
* @param {Upgradesuccesstitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const upgradesuccesstitle2 = /** @type {((inputs?: Upgradesuccesstitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgradesuccesstitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgradesuccesstitle2(inputs)
	return de_upgradesuccesstitle2(inputs)
});
export { upgradesuccesstitle2 as "upgradeSuccessTitle" }